import { render, staticRenderFns } from "./CustomerExpense.vue?vue&type=template&id=245bf07b&scoped=true&"
import script from "./CustomerExpense.vue?vue&type=script&lang=js&"
export * from "./CustomerExpense.vue?vue&type=script&lang=js&"
import style0 from "./CustomerExpense.vue?vue&type=style&index=0&id=245bf07b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245bf07b",
  null
  
)

export default component.exports